import React, { Suspense } from 'react'

import { LoadingComponent } from '../../loading'
import EnterAccountPasswordWrapper from '../../../modules/enter-account-password-modal/enter-account-password-wrapper'

const AccountDetails = React.lazy(() => import('./account-details'))

const AsyncAccountDetails = () => (
  <EnterAccountPasswordWrapper>
    <Suspense fallback={<LoadingComponent />}>
      <AccountDetails />
    </Suspense>
  </EnterAccountPasswordWrapper>
)

export default AsyncAccountDetails
